import React, { useState } from 'react';
import { Box, MenuItem, Select, TextField, Typography, IconButton } from '@mui/material';
import DownloadingOutlinedIcon from '@mui/icons-material/DownloadingOutlined';
import './studyDocumnent.css';
import axios from 'axios';
import Swal from 'sweetalert2';

const FileUploadComponent = ({ setShowSpinner, studyData }) => {
  const [file, setFile] = useState(null);
  const [fileType, setFileType] = useState('');
  const [data, setData] = useState(studyData[0] || {});


  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleTypeChange = (e) => {
    setFileType(e.target.value);
  };


  //Bearer Token
  const token = localStorage.getItem('token');
  const tokenValue = token ? token.slice(1, token.length - 1) : "";

  const handleUpload = () => {
    if (file && fileType) {

      setShowSpinner(true);
      // Assuming 'file' is the file object obtained from the input element
      const formData = new FormData();
      formData.append('file', file); // 'image' should be the key expected by your backend for the file

      let folderName;
      if (fileType === "Protocol/FQ") {
        folderName = "Protocol";
      } else if (fileType === "Budget/CTA") {
        folderName = "Budget";
      } else {
        folderName = fileType;
      }

      // Prepare the URL with query parameters
      const url = `https://research-mate-b35a10757d5a.herokuapp.com/api/adminStudy/document/${data._id}/${folderName}`;


      // Make the API request using Axios
      axios.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${tokenValue}`
          // You can add other headers if needed like authorization token, etc.
        }
      })
        .then(res => {
          // Handle success
          setData(res.data.study);
          // Perform actions like showing a success message, updating state, etc.
          Swal.fire({
            title: "Document Recieved!",
            text: "Your documents have been uploaded",
            icon: "success",
            customClass: {
              container: 'swal2-container-custom'
            }
          })
        })
        .catch(error => {
          // Handle error
          console.log('error', error)
          // Show error message to user or retry logic
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: error.response.data.message,
            customClass: {
              container: 'swal2-container-custom'
            }
          });
        })
        .finally(() => {
          setShowSpinner(false);
          setFile(null);
          setFileType('');
          // Refresh the page
          window.location.reload();  // Refreshes the page
        })

    } else {
      alert("File or file type missing")
    }
  };

  const handleDocumentClick = (link) => {
    window.open(link, '_blank');
  };

  return (
    <Box sx={{ p: 4 }}>
      <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
        <TextField
          type="file"
          onChange={handleFileChange}
          variant="outlined"
          fullWidth
        />
        <Select
          value={fileType}
          onChange={handleTypeChange}
          variant="outlined"
          displayEmpty
          fullWidth
        >
          <MenuItem value="" disabled>
            Select Type
          </MenuItem>
          <MenuItem value="SMO">SMO</MenuItem>
          <MenuItem value="CDA">CDA</MenuItem>
          <MenuItem value="Protocol/FQ">Protocol/FQ</MenuItem>
          <MenuItem value="PSSV">PSSV</MenuItem>
          <MenuItem value="Budget/CTA">Budget/CTA</MenuItem>
          <MenuItem value="SIV">SIV</MenuItem>
          <MenuItem value="Invoicing">Invoicing</MenuItem>

        </Select>
        <IconButton variant="outlined" onClick={handleUpload} sx={{ bgcolor: '#169a8f', '& .MuiSvgIcon-root': { fontSize: '2.5rem' } }}>
          <DownloadingOutlinedIcon />
        </IconButton>
      </Box>
      <Box>
        <div>
          <Box className="d-flex w-100 justify-content-start align-items-center">
            {data.step1Doc &&
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  p: 2,
                  mx: 1,
                  borderRadius: '4px',
                  width: '300px',
                  height: '50px',
                  boxShadow: 'rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset',
                }}
                onClick={() => handleDocumentClick(data.step1Doc)}
              >
                <h4 style={{ color: 'rgb(23 131 131)' }}>SMO</h4>
                <h4 style={{ color: 'rgb(23 131 131)', cursor: 'pointer' }}> <DownloadingOutlinedIcon /></h4>
              </Box>}
            {data.step2Doc &&
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  p: 2,
                  mx: 1,
                  borderRadius: '4px',
                  width: '300px',
                  height: '50px',
                  boxShadow: 'rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset',
                  cursor: 'pointer',
                }}
                onClick={() => handleDocumentClick(data.step2Doc)}
              >
                <h4 style={{ color: 'rgb(23 131 131)' }}>CDA</h4>
                <h4 style={{ color: 'rgb(23 131 131)', cursor: 'pointer' }}> <DownloadingOutlinedIcon /></h4>
              </Box>}
            {data.step3Doc &&
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  p: 2,
                  mx: 1,
                  borderRadius: '4px',
                  width: '300px',
                  height: '50px',
                  boxShadow: 'rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset',
                  cursor: 'pointer',
                }}
                onClick={() => handleDocumentClick(data.step3Doc)}
              >
                <h4 style={{ color: 'rgb(23 131 131)' }}>Protocol/FQ</h4>
                <h4 style={{ color: 'rgb(23 131 131)', cursor: 'pointer' }}> <DownloadingOutlinedIcon /></h4>
              </Box>}
            {data.step4Doc &&
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  p: 2,
                  mx: 1,
                  borderRadius: '4px',
                  width: '300px',
                  height: '50px',
                  boxShadow: 'rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset',
                  cursor: 'pointer',
                }}
                onClick={() => handleDocumentClick(data.step4Doc)}
              >
                <h4 style={{ color: 'rgb(23 131 131)' }}>PSSV</h4>
                <h4 style={{ color: 'rgb(23 131 131)', cursor: 'pointer' }}> <DownloadingOutlinedIcon /></h4>
              </Box>}
            {data.step5Doc &&
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  p: 2,
                  mx: 1,
                  borderRadius: '4px',
                  width: '300px',
                  height: '50px',
                  boxShadow: 'rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset',
                  cursor: 'pointer',
                }}
                onClick={() => handleDocumentClick(data.step5Doc)}
              >
                <h4 style={{ color: 'rgb(23 131 131)' }}>Budget/CTA</h4>
                <h4 style={{ color: 'rgb(23 131 131)', cursor: 'pointer' }}> <DownloadingOutlinedIcon /></h4>
              </Box>}
            {data.step6Doc &&
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  p: 2,
                  mx: 1,
                  borderRadius: '4px',
                  width: '300px',
                  height: '50px',
                  boxShadow: 'rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset',
                  cursor: 'pointer',
                }}
                onClick={() => handleDocumentClick(data.step6Doc)}
              >
                <h4 style={{ color: 'rgb(23 131 131)' }}>SIV</h4>
                <h4 style={{ color: 'rgb(23 131 131)', cursor: 'pointer' }}> <DownloadingOutlinedIcon /></h4>
              </Box>}
            {data.step7Doc &&
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  mx: 1,
                  p: 2,
                  borderRadius: '4px',
                  width: '300px',
                  height: '50px',
                  boxShadow: 'rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset',
                  cursor: 'pointer',
                }}
                onClick={() => handleDocumentClick(data.step7Doc)}
              >
                <h4 style={{ color: 'rgb(23 131 131)' }}>Invoicing</h4>
                <h4 style={{ color: 'rgb(23 131 131)', cursor: 'pointer' }}> <DownloadingOutlinedIcon /></h4>
              </Box>}
          </Box>
        </div>
      </Box>
    </Box>
  );
};

export default FileUploadComponent;
